// Comparte un PDF (factura, cotización, comprobante de alquiler) por WhatsApp.
//
// Un enlace de WhatsApp no puede adjuntar archivos, así que:
// 1. Si el dispositivo lo permite (celulares y algunos navegadores), se abre
//    el menú "Compartir" del sistema con el PDF adjunto para elegir WhatsApp.
// 2. Si no (ej. computador), se descarga el PDF y se abre WhatsApp (Web o app)
//    con un mensaje listo para adjuntar el archivo descargado. Si hay celular,
//    se abre directamente el chat de ese número.
//
// Devuelve "compartido" | "descargado" | "cancelado".

// Números de Colombia de 10 dígitos se completan con el indicativo 57
const normalizarCelular = (celular) => {
    const digitos = String(celular || "").replace(/\D/g, "");
    if (!digitos) return "";
    return digitos.length === 10 ? `57${digitos}` : digitos;
};

const descargar = (blob, nombreArchivo) => {
    const url = URL.createObjectURL(blob);
    const enlace = document.createElement("a");
    enlace.href = url;
    enlace.download = nombreArchivo;
    document.body.appendChild(enlace);
    enlace.click();
    enlace.remove();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
};

// Abre WhatsApp (Web o app) con el mensaje escrito; con celular, en ese chat
export const abrirChatWhatsApp = ({ mensaje, celular }) => {
    const numero = normalizarCelular(celular);
    const url = `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;
    window.open(url, "_blank", "noopener");
};

// Nota: al compartir un archivo con el menú del sistema, WhatsApp descarta el
// texto y solo envía el PDF. Por eso quien llama ofrece enviar el mensaje
// aparte cuando el resultado es "compartido".
const compartirPdfWhatsApp = async ({ blob, nombreArchivo, mensaje, celular }) => {
    const archivo = new File([blob], nombreArchivo, { type: "application/pdf" });

    if (navigator.canShare?.({ files: [archivo] })) {
        try {
            await navigator.share({ files: [archivo], title: nombreArchivo, text: mensaje });
            return "compartido";
        } catch (error) {
            // El usuario cerró el menú de compartir
            if (error?.name === "AbortError") return "cancelado";
            // Cualquier otro error: se usa el plan B
        }
    }

    descargar(blob, nombreArchivo);
    abrirChatWhatsApp({ mensaje, celular });
    return "descargado";
};

export default compartirPdfWhatsApp;
